module.exports = __webpack_public_path__ + "static/media/49.93bd239a.jpg";